{
	"actions": {
		"open_menu": "Open actions menu",
		"request_password_reset": "Request password reset",
		"resend_invite": "Resend invite email"
	},
	"columns": {
		"actions": "Actions",
		"status": "Status"
	},
	"delete_admin": {
		"description": "Permanently delete the account for {{email}}. This action cannot be undone.",
		"success": "Admin account deleted.",
		"title": "Delete admin account"
	},
	"filters": {
		"field": {}
	},
	"invite": {
		"button": "Invite admin",
		"description": "Send an invitation email to a new admin user.",
		"email_placeholder": "name@example.com",
		"error": "Failed to invite admin.",
		"name_placeholder": "Full name",
		"submit": "Send invite",
		"success": "Admin invited successfully.",
		"title": "Invite a new admin",
		"validation": {
			"email_invalid": "Enter a valid email",
			"name_invalid": "Name is required"
		}
	},
	"page_title": "Admins",
	"request_password_reset": {
		"confirm": "Send reset link",
		"description": "Send a password reset link to {{email}}. The current password will remain valid until they pick a new one.",
		"success": "Password reset link sent.",
		"title": "Request password reset"
	},
	"resend_invite": {
		"confirm": "Resend invite",
		"description": "Resend the invitation email to {{email}}. The previous link will be invalidated.",
		"success": "Invite resent.",
		"title": "Resend invite email"
	},
	"search_placeholder": "Search admin...",
	"status": {
		"active": "Active",
		"disabled": "Disabled",
		"pending": "Pending invite"
	}
}
